import api from './axios';

export const auditApi = {
  getAll: (filters?: {
    entity?: string;
    action?: string;
    userId?: number;
    from?: string;
    to?: string;
  }) => api.get('/audit', { params: filters }),
  getByEntity: (entity: string, entityId: number) =>
    api.get(`/audit/${entity}/${entityId}`),
};
